import { createContext } from 'react';

const reportContext = createContext();

export default reportContext;

